import { useEffect, useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { Button } from "@omnabase/ui";
import { recheckSignedIn, signedOutNow, subscribeSignedOut } from "../lib/signedOut";
import { signInAgainPath } from "../lib/signin";

/** "You are signed out" (the forum sync round, 2026-11-02; brief rule 9): when the session ended (it ran out, a sign-out in another tab, a
 *  revoked session) a sheet covers the app instead of a screen whose reads and saves fail silently. The rest of the page is inert while it is
 *  up; its one button goes to the sign-in page with the current place as `next`, so the proof returns there. Coming back to the tab reads
 *  `me` again, and a sign-in made in another tab closes the sheet. It uses the kit's dialog look without a close: there is nothing else to do. */
export function SignedOutSheet() {
  const out = useSyncExternalStore(subscribeSignedOut, signedOutNow);
  useEffect(() => {
    if (!out) return;
    const root = document.getElementById("root");
    root?.setAttribute("inert", "");
    const back = () => { if (document.visibilityState === "visible") recheckSignedIn(); };
    window.addEventListener("focus", back); document.addEventListener("visibilitychange", back);
    return () => { root?.removeAttribute("inert"); window.removeEventListener("focus", back); document.removeEventListener("visibilitychange", back); };
  }, [out]);
  if (!out) return null;
  const signIn = () => window.location.assign(signInAgainPath(`${window.location.pathname}${window.location.search}`)); // a fresh page: nothing of the old session is kept
  return createPortal(
    <div className="ob-dialog__backdrop ob-signed-out">
      <div className="ob-dialog ob-signed-out__sheet" role="dialog" aria-modal="true" aria-labelledby="ob-signed-out-title" style={{ width: 420 }}>
        <div className="ob-dialog__head"><h2 className="ob-dialog__title" id="ob-signed-out-title">You are signed out</h2><div className="ob-dialog__intro">Sign in again to carry on where you were.</div></div>
        <div className="ob-dialog__foot"><Button variant="primary" autoFocus onClick={signIn}>Sign in</Button></div>
      </div>
    </div>, document.body);
}
